module.exports = __webpack_public_path__ + "img/decimals.b2b562bf.svg";